export const SITE_URL = 'https://www.podiatech.uz';

// Язык по умолчанию живёт на корневых URL ('/'), остальные — с префиксом ('/ru', '/en', '/fr').
export const DEFAULT_LANGUAGE = 'uz';
export const SUPPORTED_LANGUAGES = ['uz', 'ru', 'en', 'fr'];
export const PREFIXED_LANGUAGES = SUPPORTED_LANGUAGES.filter((lang) => lang !== DEFAULT_LANGUAGE);

export const LANGUAGE_STORAGE_KEY = 'podiatech.language';

// hreflang-коды для <link rel="alternate"> и og:locale
export const HREFLANG_CODES = {
    uz: 'uz',
    ru: 'ru',
    en: 'en',
    fr: 'fr'
};

export const OG_LOCALES = {
    uz: 'uz_UZ',
    ru: 'ru_RU',
    en: 'en_US',
    fr: 'fr_FR'
};

export const isSupportedLanguage = (language) => SUPPORTED_LANGUAGES.includes(language);

const normalizePath = (path) => {
    if (!path || path === '/') return '/';
    const withSlash = path.startsWith('/') ? path : `/${path}`;
    return withSlash.length > 1 ? withSlash.replace(/\/+$/, '') : '/';
};

/**
 * '/ru/blog/posts/x' → { language: 'ru', path: '/blog/posts/x' }
 * '/blog/posts/x'    → { language: 'uz', path: '/blog/posts/x' }
 */
export const splitLanguageFromPath = (pathname = '/') => {
    const segments = normalizePath(pathname).split('/');
    const maybeLanguage = segments[1];

    if (isSupportedLanguage(maybeLanguage)) {
        return {
            language: maybeLanguage,
            path: normalizePath(`/${segments.slice(2).join('/')}`),
            hasPrefix: true
        };
    }

    return { language: DEFAULT_LANGUAGE, path: normalizePath(pathname), hasPrefix: false };
};

/**
 * ('ru', '/blog/posts/x') → '/ru/blog/posts/x'
 * ('uz', '/blog/posts/x') → '/blog/posts/x'   (язык по умолчанию — без префикса)
 */
export const localizePath = (language, path = '/') => {
    const clean = normalizePath(path);
    if (!isSupportedLanguage(language) || language === DEFAULT_LANGUAGE) return clean;
    return clean === '/' ? `/${language}` : `/${language}${clean}`;
};

export const buildCanonicalUrl = (language, path = '/') => {
    const localized = localizePath(language, path);
    return localized === '/' ? `${SITE_URL}/` : `${SITE_URL}${localized}`;
};

/** Полный набор языковых версий одной страницы — для hreflang. */
export const buildAlternateUrls = (path = '/') =>
    SUPPORTED_LANGUAGES.map((language) => ({
        language,
        hreflang: HREFLANG_CODES[language],
        url: buildCanonicalUrl(language, path)
    }));

export const getStoredLanguage = () => {
    try {
        const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
        return isSupportedLanguage(stored) ? stored : null;
    } catch {
        return null;
    }
};

export const storeLanguage = (language) => {
    if (!isSupportedLanguage(language)) return;
    try {
        window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    } catch {
        /* приватный режим — просто не запоминаем */
    }
};
